import { StatProps, Text, UsdPriceTextWithTooltip } from "@bridgesplit/ui";
import { formatPercent, formatUsd } from "@bridgesplit/utils";
import { StrategiesAggregate } from "@bridgesplit/abf-react";

import { useActivePortfolioRewardsSummary } from "./util";
import { PortfolioTableStats, RewardPoint } from "./common";
import { COPY } from "../../../constants";

export default function LenderLoanStats({ aggregate }: { aggregate: StrategiesAggregate | undefined }) {
    const portfolioRewards = useActivePortfolioRewardsSummary();
    const loading = !aggregate || !portfolioRewards || portfolioRewards.isLoading;

    // Standardized section-stats order: Total value → APY → Daily interest → Daily rewards.
    const stats: StatProps[] = [
        {
            value: (
                <UsdPriceTextWithTooltip textColor="body" rawUsdValue={aggregate?.totalSupplyUsd} loading={loading} />
            ),
            caption: COPY.TOTAL_SUPPLIED_TERM
        },
        {
            value: formatPercent(aggregate?.wAvgApy),
            caption: COPY.APY_TERM
        },
        {
            value: <Text translate="no">{formatUsd(aggregate?.expected24hInterestUsd)}</Text>,
            caption: COPY.DAILY_INTEREST_TERM
        },
        {
            value: <Text translate="no">{formatUsd(aggregate?.interestEarnedAllTimeUsd)}</Text>,
            caption: COPY.TOTAL_INTEREST_EARNED_TERM
        },
        {
            value: <RewardPoint points={portfolioRewards?.data?.activeStrategyDailyLendPoints ?? 0} variant="body1" />,
            caption: COPY.DAILY_REWARDS_TERM
        }
    ];
    return <PortfolioTableStats stats={stats} loading={loading} />;
}
